import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    loadingStatus: "idle",
    error: null
}

export const sendForm = createAsyncThunk(
    'sendForm',
    async({body, url, method = "POST", token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }


            const response = await request(
                `${APP_URL}${url}`,
                method,
                body,
                customHeaders
            )

            console.log(response);

            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
);

const sendFormSlice = createSlice({
    name: 'sendForm',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(sendForm.pending, (state) => {
                state.loadingStatus = 'loading';
                state.error = null
            })
            .addCase(sendForm.fulfilled, (state) => {
                state.loadingStatus = 'idle';
                state.error = null;
            })
            .addCase(sendForm.rejected, (state, action) => {
                state.loadingStatus = 'error';
                state.error = action.payload;
            })
    }
})

export default sendFormSlice.reducer;